import pureData from './pureData/Module'
import puredata_en from './pureData/en'

export default {
  pureData,
};

export var translations = {
  en: {puredata: puredata_en},
};


// WEBPACK FOOTER //
// ./src/apps/feelgrid/modules/index.js